export var FDishTypeEnum;
(function (FDishTypeEnum) {
    FDishTypeEnum["Dessert"] = "DESSERT";
    FDishTypeEnum["Main"] = "MAIN";
    FDishTypeEnum["Starter"] = "STARTER";
})(FDishTypeEnum || (FDishTypeEnum = {}));
